import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SettingsPagesContainer from "../../../../components/settingsPagesContainer/SettingsPagesContainer";
import { fetchAdmins } from "../../../../features/admins/adminsSlice";
import { fetchControlledHierarchy } from "../../../../features/controlledHierarchy/controlledHierarchySlice";
import OneHierarchy from "./oneHierarchy/OneHierarchy";
import styles from "./controlHierarchy.module.css";

const ControlHierarchy = () => {
  const dispatch = useDispatch();
  const { hierarchy, fetchStatus: hierarchyFetchStatus } = useSelector(
    (state) => state.controlledHierarchy
  );

  const { fetchStatus: adminsFetchStatus } = useSelector(
    (state) => state.admins
  );

  useEffect(() => {
    if (adminsFetchStatus === "idle") {
      dispatch(fetchAdmins());
    }
  }, [adminsFetchStatus, dispatch]);

  const displayHierarchies = hierarchy?.data?.map((item) => {
    return <OneHierarchy key={item._id} item={item} />;
  });

  useEffect(() => {
    if (hierarchyFetchStatus === "idle") {
      dispatch(fetchControlledHierarchy());
    }
  }, [hierarchyFetchStatus, dispatch]);

  return (
    <SettingsPagesContainer
      title={"التحكم في تسلسل الموظفين"}
      fullHeight
      displayContainerClassName={styles.hierarchyPanel}
    >
      {displayHierarchies}
    </SettingsPagesContainer>
  );
};

export default ControlHierarchy;
